(function () {
  function init(root) {
    root = root || document;
    var section = root.querySelector('.rn-product');
    if (!section) return;

    // ---- Thumbnail -> main image ----
    var mainImg = section.querySelector('#rn-main-img');
    var thumbs = section.querySelectorAll('[data-rn-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var img = t.getAttribute('data-img');
        if (img && mainImg) mainImg.src = img;
      });
    });

    // ---- Variant data ----
    var variants = [];
    var vEl = section.querySelector('[data-rn-variants]');
    if (vEl) { try { variants = JSON.parse(vEl.textContent); } catch (e) {} }

    var swatches = section.querySelectorAll('[data-rn-swatch]');
    var nameEl = section.querySelector('[data-rn-swatch-name]');
    var idInput = section.querySelector('[data-rn-variant-id]');
    var priceEl = section.querySelector('[data-rn-price]');
    var compareEl = section.querySelector('[data-rn-compare]');

    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        swatches.forEach(function (x) { x.classList.remove('is-active'); });
        sw.classList.add('is-active');
        var val = sw.getAttribute('data-value');
        if (nameEl) nameEl.textContent = val;

        var match = variants.filter(function (v) { return v.option1 === val; })[0];
        if (match) {
          if (idInput) idInput.value = match.id;
          if (priceEl && match.price) priceEl.textContent = match.price;
          if (compareEl) { compareEl.textContent = (match.compare && match.compare !== match.price) ? match.compare : ''; }
          if (mainImg && match.img) {
            mainImg.src = match.img;
            thumbs.forEach(function (x) { x.classList.remove('is-active'); });
          }
        }
      });
    });

    // ---- Optional tabs / FAQ (only if present) ----
    section.querySelectorAll('[data-rn-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-rn-tab');
        section.querySelectorAll('[data-rn-tab]').forEach(function (t) { t.classList.remove('is-active'); });
        section.querySelectorAll('[data-rn-panel]').forEach(function (p) { p.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var panel = section.querySelector('[data-rn-panel="' + target + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });

    section.querySelectorAll('[data-rn-faq-q]').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.closest('[data-rn-faq]');
        if (item) item.classList.toggle('is-open');
      });
    });

    /* Image carousel */
    (function () {
      var main = section.querySelector('.rn-media-main');
      var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-rn-thumb]'));
      if (!main || !thumbs.length || main.querySelector('.rn-carousel-track')) return;

      main.classList.add('rn-carousel');
      main.innerHTML = '';
      var track = document.createElement('div');
      track.className = 'rn-carousel-track';

      thumbs.forEach(function (t, i) {
        var slide = document.createElement('div');
        slide.className = 'rn-carousel-slide';
        var type = t.getAttribute('data-media-type');

        if (type === 'model') {
          slide.className += ' rn-carousel-slide--model';
          var mv = document.createElement('model-viewer');
          mv.setAttribute('src', t.getAttribute('data-model-src') || '');
          mv.setAttribute('alt', t.getAttribute('data-model-alt') || '');
          mv.setAttribute('camera-controls', '');
          mv.setAttribute('auto-rotate', '');
          mv.setAttribute('ar', '');
          mv.setAttribute('loading', i === 0 ? 'eager' : 'lazy');
          mv.setAttribute('reveal', 'auto');
          slide.appendChild(mv);
        } else {
          var img = document.createElement('img');
          img.src = t.getAttribute('data-img');
          img.alt = (t.querySelector('img') && t.querySelector('img').alt) || '';
          img.loading = i === 0 ? 'eager' : 'lazy';
          if (i === 0) img.id = 'rn-main-img';
          slide.appendChild(img);
        }
        track.appendChild(slide);
      });
      main.appendChild(track);

      var prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'rn-car-arrow rn-car-prev';
      prev.setAttribute('aria-label', 'Previous');
      prev.innerHTML = '\u2039';
      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'rn-car-arrow rn-car-next';
      next.setAttribute('aria-label', 'Next');
      next.innerHTML = '\u203a';
      main.appendChild(prev);
      main.appendChild(next);

      function w() { return track.clientWidth; }
      function cur() { return Math.round(track.scrollLeft / w()); }
      function go(i) {
        i = Math.max(0, Math.min(thumbs.length - 1, i));
        track.scrollTo({ left: i * w(), behavior: 'smooth' });
      }
      prev.addEventListener('click', function () { go(cur() - 1); });
      next.addEventListener('click', function () { go(cur() + 1); });
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });

      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var c = cur();
          thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === c); });
        });
      });
    })();

    /* Thumbnail carousel */
    (function () {
      var thumbs = section.querySelector('.rn-media-thumbs');
      if (!thumbs || thumbs.parentElement.classList.contains('rn-thumbs-wrap')) return;
      var count = thumbs.querySelectorAll('.rn-thumb').length;
      var wrap = document.createElement('div');
      wrap.className = 'rn-thumbs-wrap';
      thumbs.parentNode.insertBefore(wrap, thumbs);
      wrap.appendChild(thumbs);
      var tp = document.createElement('button');
      tp.type = 'button';
      tp.className = 'rn-thumbs-arrow rn-thumbs-prev';
      tp.setAttribute('aria-label', 'Previous thumbnails');
      tp.innerHTML = '\u2039';
      var tn = document.createElement('button');
      tn.type = 'button';
      tn.className = 'rn-thumbs-arrow rn-thumbs-next';
      tn.setAttribute('aria-label', 'Next thumbnails');
      tn.innerHTML = '\u203a';
      wrap.appendChild(tp);
      wrap.appendChild(tn);
      function step() { var t = thumbs.querySelector('.rn-thumb'); return t ? t.getBoundingClientRect().width + 10 : 70; }
      function limit() { return window.matchMedia('(max-width:749px)').matches ? 4 : 8; }
      function upd() {
        var active = count > limit();
        wrap.classList.toggle('rn-thumbs-carousel', active);
        wrap.classList.toggle('no-scroll', !active || thumbs.scrollWidth <= thumbs.clientWidth + 2);
      }
      tp.addEventListener('click', function () { thumbs.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      tn.addEventListener('click', function () { thumbs.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      upd();
      window.addEventListener('resize', upd);
    })();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
})();

/* Sync gallery image to selected color swatch */
(function () {
  function rnBase(u) { return String(u).split('/').pop().split('?')[0].replace(/_\d+x\d*(?=\.)/, ''); }
  function rnInit() {
    document.querySelectorAll('.rn-product').forEach(function (section) {
      var vEl = section.querySelector('script[type="application/json"][data-rn-variants]');
      if (!vEl) return;
      var variants;
      try { variants = JSON.parse(vEl.textContent); } catch (e) { return; }
      var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-rn-thumb]'));
      section.querySelectorAll('[data-rn-swatch]').forEach(function (sw) {
        sw.addEventListener('click', function () {
          var val = sw.getAttribute('data-value');
          var match = variants.filter(function (v) { return v.option1 === val; })[0];
          if (!match || !match.img) return;
          var tgt = rnBase(match.img);
          var thumb = thumbs.filter(function (t) {
            return t.getAttribute('data-media-type') !== 'model'
              && rnBase(t.getAttribute('data-img')) === tgt;
          })[0];
          if (thumb) thumb.click();
        });
      });
    });
  }
  if (document.readyState !== 'loading') rnInit();
  else document.addEventListener('DOMContentLoaded', rnInit);
})();